import { render, staticRenderFns } from "./GroupsPage.vue?vue&type=template&id=58b86293&scoped=true&"
import script from "./GroupsPage.vue?vue&type=script&lang=ts&"
export * from "./GroupsPage.vue?vue&type=script&lang=ts&"
import style0 from "./GroupsPage.vue?vue&type=style&index=0&id=58b86293&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b86293",
  null
  
)

export default component.exports